/**
 * Utility function to determine if the current execution context is in the browser.
 * Helps avoid ReferenceErrors when accessing `window` during Server-Side Rendering (SSR).
 */
export const isBrowser = () => typeof window !== 'undefined';